

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface CustomAlertIconStyles {
    alertMessageIcon?: InjectableCss;
}

export const customAlertIconStyles: CustomAlertIconStyles = {
    alertMessageIcon: {
        css: css`
           width: 16px;
            svg {
                height: 16px !important;
                width: 16px !important;
            }
        `,
    },
};

const styles = customAlertIconStyles;

const CustomAlertIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.alertMessageIcon}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M13.8656 11.7734L8.86639 3.24219C8.48365 2.58594 7.51779 2.58594 7.13248 3.24219L2.13559 11.7734C1.75098 12.4273 2.23002 13.25 3.00091 13.25H12.9994C13.7672 13.25 14.2476 12.4297 13.8656 11.7734ZM7.4367 5.9375C7.4367 5.62695 7.68865 5.375 7.9992 5.375C8.30974 5.375 8.5617 5.62812 8.5617 5.9375V8.9375C8.5617 9.24805 8.30974 9.5 8.02029 9.5C7.73084 9.5 7.4367 9.24922 7.4367 8.9375V5.9375ZM7.9992 11.75C7.59232 11.75 7.26232 11.42 7.26232 11.0131C7.26232 10.6062 7.59209 10.2762 7.9992 10.2762C8.40631 10.2762 8.73607 10.6062 8.73607 11.0131C8.73514 11.4195 8.40701 11.75 7.9992 11.75Z" fill="#262525"/>
              </svg>
        </StyledWrapper>
    );
};

export default React.memo(CustomAlertIcon);
